import React, { ReactNode } from "react";
import { useDrag, useDrop } from "react-dnd";

interface DragItem {
  section: string;
  index: number;
  type: string;
}

interface DraggableCardProps {
  section: string;
  index: number;
  type: string;
  onMoveCard: (dragSection: string, hoverSection: string, dragIndex: number, hoverIndex: number) => void;
  children: ReactNode;
}

const DraggableCard: React.FC<DraggableCardProps> = ({
  section,
  index,
  type,
  onMoveCard,
  children,
}) => {
  const [{ isDragging }, ref] = useDrag({
    type,
    item: { index, section },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  });

  const [{ isOver }, drop] = useDrop({
    accept: type,
    drop: (item: DragItem) => {

      if (item.section === section  && item.index === index) return;

        onMoveCard(item.section, section, item.index, index);
        // item.index = index;
        // item.section = section;
    },
    collect: (monitor) => ({
      isOver: monitor.isOver(),
    }),
  });

  return (
    <div
      ref={(node) => ref(drop(node))}
      style={{
        width: "100%",
        cursor: isDragging ? "grabbing" : "grab",
        border: isOver ? "2px dashed #82e1f2" : "2px solid transparent",
        borderRadius: "8px",
        boxShadow: isOver ? "0 0 10px rgba(130, 225, 242, 0.5)" : "none",
        transition: "border 0.2s ease",
      }}
    >
      {children}
    </div>
  );
};

export default DraggableCard;
